module.exports = __webpack_public_path__ + "img/ico_sms-accent.646ca574.svg";